import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

class EmployerField extends Component {
  render() {
    let label = "Employer";
    if(this.props.status === "SelfEmployed") {
      label = "Company Name"
    }
    return (
      <div>
        <FormGroup>
          <Label for="employer">{label}</Label>
          <Input name="employer" id="employer" value={this.props.employer} onChange={this.props.handleChange} onBlur={this.props.validateField} invalid={this.props.validation.employer.isInvalid} maxLength="35" autoComplete="off" autoCapitalize="off" autoCorrect="off" />
          <FormFeedback>{this.props.validation.employer.message}</FormFeedback>
        </FormGroup>                                                     
      </div>);
  }
}
EmployerField.defaultProps= {
  handleChange:() => {},
  validation: {
    employer: {
      isInvalid: false,
      message: ""
    }
  }
};

EmployerField.propTypes = {
  handleChange: PropTypes.func,
};

export default EmployerField;


// WEBPACK FOOTER //
// ./src/components/Fields/Occupation/EmployerField.js